export default __webpack_public_path__ + "static/media/prize.2b2230ac.svg";